import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientNegotiateContent のスタイル
 */
export const hotlineClientNegotiateContentStyle = tv({
    slots: {
        alert: ['mt-24'],
        base: ['block md:hidden lg:block xl:hidden'],
        chatWrap: ['mt-8 ml-12'],
        closeButton: ['block md:hidden lg:block xl:hidden'],
        content: [
            'border border-solid border-dark',
            'overflow-y-auto',
            'p-16',
            'h-auto md:max-h-[494px]',
        ],
        contentWrap: [
            'transition-[height] md:transition-none lg:transition-[height] xl:transition-none duration-[250ms]',
            'overflow-y-hidden h-0 md:h-auto lg:h-0 xl:h-auto',
        ],
        headWrap: ['flex items-center gap-8'],
        scheduleContent: ['mt-24'],
        tag: ['flex-shrink-0'],
    },
});
